import Props from "./props";
import React from "react";
import Styled from "./styled";

const Item: React.FC<Props> = ({ children, onClick, isSubLevel, active }) => {
    return (
        <Styled active={active} isSubLevel={isSubLevel} onClick={onClick}>
            {children}
        </Styled>
    );
};

export default Item;
